import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { TransactionAccountProduct } from '@css-xp/graphtypes/src/generated-types-new';
import './add-ons-count-cell.scss';

export const getAddOnsCount = (subscription: TransactionAccountProduct) => {
  return subscription?.linkedAddOnsId?.length ?? 0;
};

export interface AddOnsCountCellProps {
  subscription: TransactionAccountProduct;
  baseRoute?: string;
}

export const AddOnsCountCell = ({ subscription, baseRoute }: AddOnsCountCellProps) => {
  const count = getAddOnsCount(subscription);
  const renderCount = () => {
    return (
      <span className={classNames({ 'add-ons-count-cell-empty': count === 0 }, 'add-ons-count-cell')}>{count}</span>
    );
  };
  const isCountEmpty = count === 0;

  return (
    <td className="add-ons-count-container">
      {isCountEmpty ? (
        renderCount()
      ) : (
        <Link to={baseRoute ? `${baseRoute}${subscription.id}#add-ons` : ''}>{renderCount()}</Link>
      )}
    </td>
  );
};
